import {PropertyReference} from "../../../javascript.lib.mojo-base/product.facilities/Property";


export class UserPropertyView {

  constructor( public property: PropertyReference, public include: boolean ) {
  }
}
